import { Button } from "@aidron/aidron-ds";

import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";

import PropTypes from "prop-types";

export function TableDownloadButton({ ctx, uiState }) {

  const {
    fileName,
    tableInfo,
    tableId = "download-table",
    sheetName = "Export",
    defaultFileName = "export",
    hideOnExport = [],
    getExportRows,
  } = ctx || {};

  const {
    size = "sm",
    buttonType = "outlined",
    icon = "download",
    disabled = false,
    isStoresTable = false,
    useCustomIcon = false,
    iconColor = "#555",
    borderColor = "#ddd",
    customIconSize = 24
  } = uiState || {};

  const exportToExcel = () => {
    const storeName = tableInfo?.name;

    let ws;

    if (getExportRows) {
      ws = XLSX.utils.aoa_to_sheet(getExportRows());
    } else {
      const table = document.getElementById(tableId);
      if (!table) return;

      const clonedTable = table.cloneNode(true);
      let tableToExport = clonedTable;

      if (hideOnExport.length > 0) {
        clonedTable.querySelectorAll('.hide-on-export').forEach(element => {
          element.remove();
        });
      }

      if (isStoresTable) {

        clonedTable.querySelectorAll("span.only-to-export-no-styles-added-subgroup")
          .forEach(span => {
            span.textContent = span.getAttribute("title");
          });

        clonedTable.querySelectorAll("span.only-to-export-no-styles-added-product")
          .forEach(span => {
            span.textContent = span.getAttribute("title");
          });
      }

      ws = XLSX.utils.table_to_sheet(tableToExport);
    }

    if (isStoresTable && tableInfo) {
      const { cnpj, address } = tableInfo;
      const range = XLSX.utils.decode_range(ws["!ref"]);
      const newData = {};

      for (let row = range.s.r; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const oldAddr = XLSX.utils.encode_cell({ r: row, c: col });
          const newAddr = XLSX.utils.encode_cell({ r: row + 4, c: col });
          if (ws[oldAddr]) {
            newData[newAddr] = ws[oldAddr];
            delete ws[oldAddr];
          }
        }
      }

      Object.assign(ws, newData);

      ws["!ref"] = XLSX.utils.encode_range({
        s: { r: 0, c: range.s.c },
        e: { r: range.e.r + 4, c: range.e.c },
      });

      XLSX.utils.sheet_add_aoa(
        ws,
        [[storeName], [cnpj], [address], [""]],
        { origin: "A1" }
      );
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, isStoresTable ? "" : sheetName);

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const data = new Blob([excelBuffer], { type: fileType });

    FileSaver.saveAs(data, `${fileName ?? storeName ?? defaultFileName}.xlsx`);
  };

  if (useCustomIcon) {
    return (
      <button
        onClick={exportToExcel}
        title="Exportar Excel"
        disabled={disabled}
        style={{
          background: "none",
          border: `1px solid ${borderColor}`,
          borderRadius: "50%",
          width: `${customIconSize}px`,
          height: `${customIconSize}px`,
          cursor: disabled ? "default" : "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          opacity: disabled ? 0.5 : 1,
        }}
      >
        <svg
          width={Math.round(customIconSize * 0.66)}
          height={Math.round(customIconSize * 0.66)}
          viewBox="0 0 24 24"
          fill="none"
          stroke={iconColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
          <polyline points="7,10 12,15 17,10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
      </button>
    );
  }

  return (
    <Button
      label=""
      type={buttonType}
      size={size}
      disabled={disabled}
      onClick={exportToExcel}
      icon={typeof icon === "string" ? icon : undefined}
    >
      {typeof icon !== "string" ? icon : null}
    </Button>
  );
}


TableDownloadButton.propTypes = {
  fileName: PropTypes.string,
  size: PropTypes.string,
  isStoresTable: PropTypes.bool,
  tableInfo: PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.string,
    cnpj: PropTypes.string
  })
}